import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, input, OnInit} from '@angular/core';
import {NEVER, Observable, switchMap} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {destroy$} from '../../../components/destroyable';
import {DynRemote} from '../../../components/dynamic-xyz/dyn-xyz-wc/dyn-remote';
import {DynamicZyxDaemonService} from '../../../components/dynamic-xyz/dynamic-zyx-daemon.service';
import {L10nModule} from '../../../components/translate';

const NO_AUTH_CLASS = '-no-auth';

@Component({
    selector:        'dyn-auth-widget-body',
    templateUrl:     './dyn-auth-widget-body.component.html',
    styleUrl:        './dyn-auth-widget-body.component.scss',
    imports: [
        L10nModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynAuthWidgetBodyComponent implements OnInit {

    @HostBinding(`class.${NO_AUTH_CLASS}`)
    public isVisible: boolean = false;

    public readonly title = input<string>('');

    public dynRemote: DynRemote;

    private readonly destroy$ = destroy$();

    constructor(
        public dynamicZyxDaemonService: DynamicZyxDaemonService,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    public ngOnInit(): void {
        this.dynamicZyxDaemonService.dynRemote$.pipe(
            switchMap(dynRemote => {
                if (dynRemote !== this.dynRemote) {
                    this.dynRemote = dynRemote;
                    this.changeDetectorRef.markForCheck();
                }

                return dynRemote
                    ? this.listenToDynAuth()
                    : NEVER;
            }),
            takeUntil(this.destroy$)
        ).subscribe();
    }

    private listenToDynAuth(): Observable<any> {
        return this.dynRemote.isLoggedIn$.pipe(
            switchMap(isLoggedIn => {
                this.isVisible = !isLoggedIn;
                this.changeDetectorRef.markForCheck();

                return NEVER;
            })
        );
    }

}
